import { createContext } from 'react';

const CrewContext = createContext({});

export default CrewContext;
